import React, { useState, useEffect, useMemo } from "react";
import {
 Divider, FormControl, FormControlLabel, FormLabel, Icon, IconButton, InputLabel, MenuItem, Radio, RadioGroup, Select, Stack, TextField, Tooltip, Typography,
 useTheme,
} from "@mui/material";
import {
  Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Paper, Button,
} from "@mui/material";
import { useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import _, { set } from "lodash";

import { createFilter } from 'react-search-input';
import OpenInNewOutlinedIcon from '@mui/icons-material/OpenInNewOutlined';
import { locationsSelector } from "../../../store/slices/location";
import { gmbSelector, getAccounts, removeToken } from "../../../store/slices/gmb";
import MainCard from "../common/mainCard";
import { convertArrayToDictionary } from "../../../common/utils";
import WarningAmberOutlinedIcon from '@mui/icons-material/WarningAmberOutlined';

const checkIfAllAccountIdsAreNull = (dataSets, key) => {
  return _.every(dataSets, dataset => _.every(dataset, entry => entry[key] === null));
};

const baseLocationURL = "https://www.google.com/maps/place/?q=place_id:";
const LocationList = ({ companyId, locationTypeId, userRoles, selectedAccount, setSelectedAccount }) => {
  const [data, setData] = useState({});


  const isGPSCall = localStorage.getItem('googleToken') === 'gps';
  const isAuthenticated = localStorage.getItem('gpsAuthentication') === 'true'
  const isIRUser = React.useMemo(() => userRoles?.indexOf("IRUser") >= 0, [userRoles]);
  const [selectedRows, setSelectedRows] = useState([]);
  const { accountsData, isGmbLoading, } = useSelector(gmbSelector);
  const { locations } = useSelector(locationsSelector);
  const [openNoLocationModal, setOpenNoLocationModal] = useState(false)
  const [searchText, setSearchText] = useState('');
  const locationsSourcePlaceIdList = useMemo(() => {
    return _.map(locations, (it) => it.sourcePlaceId);
  }, [locations]);

  const [errorMessage, setErrorMessage] = useState(null);
  const [openwarning, setOpenWarning] = useState(false);
  const [filterSelected, setFilterSelect] = useState(false);
  const [selectedAccountName, setSelectedAccountName] = useState("");
  const [openCollapse, setOpenCollapse] = useState(false);
  const [accountData, setAccountData] = useState("");
//   const [selectedRow, setSelectedRow] = useState({});
 
  const theme  = useTheme();
  const dispatch = useDispatch();
  const isMobile = false;
  useEffect(() => {
    dispatch(getAccounts());
  }, []);
  const locationDic = useMemo(() => convertArrayToDictionary(locations, 'sourcePlaceId'), [locations])
  const returnTableData = (data, locationsSourcePlaceIdList, isFilter = true) => {
    // if (loading) return {}

  
    const KEYS_TO_FILTERS = [
      'locationName',
      'locationId',
      'placeId',
      'category',
      'addressLine1',
      'addressLine2',
      'postalCode',
      'locality',
      'administrativeArea',
      'accountName',
    ];
    // const AccountList = _.flatten(_.map(statusSuccess, 'data'))
    const uniqList = _.uniqBy(data, 'locationId')
    let f1 = _.map(uniqList, entry => {
      return ({
        addressLine1: entry.address?.addressLines[0],
        addressLine2: entry.address?.addressLines[1],
        postalCode: entry.address?.postalCode,
        locality: entry.address?.locality,
        administrativeArea: entry.address?.administrativeArea,
        isLocaction: entry?.locationId && entry.placeId ? 1 : 0,
        alreadyAdded: _.includes(locationsSourcePlaceIdList, entry.placeId)
        , ...entry,
      });
    })
    if (filterSelected && isFilter) {
      f1 = _.filter(f1, it => { return (it.sourceId) });
    }
    let filteredData = f1
    if (isFilter) {
      filteredData = (filteredData ?? []).filter(createFilter(searchText, KEYS_TO_FILTERS));
    }
    const ff = _.groupBy(filteredData, 'accountId')

    return ff;
  }
  const tableData = React.useMemo(() => returnTableData(accountsData, locationsSourcePlaceIdList, false), [accountsData, locationsSourcePlaceIdList, filterSelected, searchText])
  const locationList = React.useMemo(() => _.flatMap(_.values(tableData)), [tableData]);
  useEffect(() => {
    if (_.sumBy(locationList, 'isLocaction') === 1 && !(_.sumBy(locationList, 'alreadyAdded') > 0)) {
      setSelectedRows(_.filter(locationList,x=>x?.placeId))
    //   setSelectedAccount(_.filter(locationList,x=>x?.placeId)?.[0])
    }
  }, [locationList])



  const handleCheckboxClick = (event, rowData) => {

     
    setSelectedRows(rowData)
    setSelectedAccount(rowData)
  };

  const _setErrorMessage = (error) => {
    switch (error) {
      case 'invalid_grant':
        setErrorMessage("Token has been expired or revoked. Kindly add your account again.");
        break;
    }
  }
  useEffect(() => {
    if (!isGmbLoading && _.size(accountsData) > 0) {
      // if (_.size(accountsData) <= 0) {
      //   setOpenNoLocationModal(true)
      // } 

      var errorObj = _.find(_.map(accountsData, 'data'), d => !_.isEmpty(d?.error))
      if (errorObj) {
        setErrorMessage(null)
        _setErrorMessage(errorObj.error)
      }
      if (checkIfAllAccountIdsAreNull(accountsData, 'locationId') && _.size(accountsData) > 0) {
        setOpenNoLocationModal(true)
      }
    }

  }, [accountsData, isGmbLoading])

  const navigate = useNavigate();

  const _removeToken = (accountId) => {
    dispatch(removeToken(accountId, companyId));
  };
  const categoryList = useMemo(() => _.sortBy(_.uniqBy(selectedRows, 'category'), 'category'), [selectedRows])
  useEffect(() => {
    if (accountsData) {
      let dataList = returnTableData(accountsData, locationsSourcePlaceIdList)
      setData(dataList);
    }
  }, [accountsData, filterSelected, searchText, locationsSourcePlaceIdList]);


 
  useEffect(() => {

    if (!_.isEmpty(errorMessage)) {
      setOpenNoLocationModal(true);
    }
  }, [errorMessage])

  const emptyClick = (rowData = null) => {
    if (rowData) {
      setSelectedAccount([rowData]);
    }
  }



  const noLocations=useMemo(()=>{
    return _.filter(Object.keys(data),account=>_.some(data[account],a=>a.isLocaction===1))
  },[data])



  const accountList = useMemo(()=>{
      const dt = _.map(accountsData, a=>a?.accountId)
        return _.uniq(dt);
  },[accountsData])


  useEffect(()=>{
    if(accountList?.length>0){
        setAccountData(accountList[0]);
        setSelectedAccount(data?.[accountList[0]]?.[0]);
    }
  },[accountList, data, setSelectedAccount])

  const handleChangeAccount = (event)=>{
    setAccountData(event.target.value);
    const dt = data?.[event.target.value];
   setSelectedAccount(data?.[dt]?.[0])
  }



  return (
    <> 
    {/* {isGPSCall &&
      <AuthenticationMessage error={!isAuthenticated} />
    } */}
      {!isGPSCall &&
        <div style={{ marginTop: "24px" }}>
          <MainCard sx={{ '& .MuiCardContent-root': { p: isMobile ? 2 : 3 } }} >
            <div>
               
              <div style={{ display: "flex", marginTop: "10px", justifyContent: 'space-between', alignItems: 'center' }}>
               
              </div>

            
            </div>
            {/* <Divider /> */}
            <div style={{  height: isMobile?'auto':'calc(100vh - 240px)',  overflow: "auto" }}>
              <div >
                
                {/* <TextField sx={{ minWidth: 100, maxWidth: 250 }} size={"small"} endAdorment onChange={onSearchChange} value={searchText} label="Search"/> */}
                 <Stack direction={'row'} spacing={2} alignItems={'center'} mt={1}>
                    <FormControl size="small" sx={{minWidth: 300, mt:1}}>
                        <InputLabel id="demo-simple-select-label">Select Account</InputLabel>
                        <Select
                        labelId="demo-simple-select-label"
                        id="demo-simple-select"
                        value={accountData}
                        label="Select Account"
                        onChange={handleChangeAccount}
                        >
                            {_.map(accountList, (account) => (<MenuItem value={account}>{account}</MenuItem>))}
                        
                        
                        </Select>
                    </FormControl>

                    { <Stack direction={'row'} spacing={5} >
                    {_.sumBy(locationList, 'alreadyAdded') > 0 &&
                      <Stack direction={'row'} spacing={2} pt={1} sx={{ alignItems:'center', cursor:'pointer'}}>
                        <span>
                        <input
                          type="checkbox"
                          style={{ cursor: "pointer", marginTop: '-10px' }}
                          onChange={(e) => setFilterSelect(e.target.checked)}
                          id="alreadyAdded"
                          checked={filterSelected}
                        />
                        </span>
                        <label htmlFor="alreadyAdded">Already added  </label>
                      </Stack>
                    }

                  </Stack>
                }
                </Stack>
                <Divider sx={{ my: 2 }} />
                {data?.[accountData] && _.filter(Object.keys(data), a=>a===accountData).map((accountName) => (
                  <div key={accountName}>
                    <p style={{ display: "flex", justifyContent: "space-between", marginBottom: "5px", }} >
                      <span>
                        Account Name: {data[accountName][0].accountName} (
                        {data[accountName][0].accountId})
                        &emsp;
                        <i style={{whiteSpace: isMobile?'nowrap':'normal'}}>{_.size(_.filter(tableData[accountName],it=>it?.isLocaction>0))+` location${_.size(_.filter(tableData[accountName],it=>it?.isLocaction>0))?'s':''}`}</i>
                      </span>
                   
                    </p>

                   <>
                   
                       <TableContainer sx={{ border: "none", mb: 5, maxHeight: isMobile?'calc(100vh - 279px)':'auto', overflow: 'auto', boxShadow: "none" }} component={Paper} >
                      <Table className="locationTable"
                        sx={{ border: "none", overflow: "auto" }}
                      >
                        <TableHead sx={{ border: "none" }}>
                          <TableRow sx={{ border: "none" }}>
                            {/* <TableCell sx={{ width: '50px' }}></TableCell> */}
                            <TableCell sx={{ width: '40%' }}>Location </TableCell>
                            <TableCell>Address</TableCell>
                          </TableRow>
                        </TableHead>
                        {(_.size(data[accountName])>0&&_.some(data[accountName],a=>a.isLocaction===1))&&<TableBody>
                          {data[accountName].map((item, index) => (
                            item?.locationId && <TableRow sx={{bgcolor: item?.locationId===selectedAccount?.locationId? "#c2ddfb" :'transparent', cursor:'pointer'}} key={index}  onClick={() => handleCheckboxClick({ target: { checked: (!_.findIndex(selectedRows, a => a.locationId === item.locationId) > -1) } }, item)}>

                              <TableCell sx={{ width: '40%' }}>
                               <div>
                                 
                                      <Typography variant="h6">{item.locationName} 
                                        {item?.placeId && <Tooltip title="Open Website" placement="top" arrow disableInteractive>
                                          <IconButton
                                            component={'a'}
                                            target="_blank"
                                            href={`${baseLocationURL}${item?.placeId}`}
                                            // onClick={()=>{logUIActions('Settings/Locations/locations', 'Icon', 'OpenInNewTab', Events.Clicked)}}
                                            color="primary"
                                            sx={{width:'16px', height:'16px', marginLeft:'4px'}}
                                            >
                                                <OpenInNewOutlinedIcon sx={{fontSize:'16px', width:'16px !important', height:'16px !important'}}/>
                                          </IconButton>
                                        </Tooltip>}
                                      </Typography>
                                      
                                  <Typography>{item.category}</Typography>
                                  <Typography>
                                    <b>Location Id: </b> {item.locationId}
                                  </Typography>
                                  <Typography>
                                    <b>Place Id: </b> {item.placeId}
                                  </Typography>
                                  <Typography className="text-muted">{item?.sourceId?"Added":"Not Added"}</Typography>
                                </div>
                              </TableCell>

                              <TableCell>
                                {item.address ? (
                                 <div>
                                    <Typography style={{marginTop:'0px !important'}}>
                                      <b>Address Line1:</b>{" "}
                                      {item.address.addressLines[0]}
                                    </Typography>
                                    <Typography style={{marginTop:'0px !important'}}>
                                      <b>Address Line2:</b>{" "}
                                      {item.address.addressLines[1]}
                                    </Typography>
                                    <Typography style={{marginTop:'0px !important'}}>
                                      <b>Locality:</b> {item.address.locality}
                                    </Typography>
                                    <Typography style={{marginTop:'0px !important'}}>
                                      <b>Administrative Area:</b>{" "}
                                      {item.address.administrativeArea}
                                    </Typography>
                                     <span style={{marginTop:'0px !important',display:'flex',gap:16,alignItems:'center'}}>
                                      <Typography>
                                      <b>Postal Code:</b> {item.address.postalCode}
                                      </Typography>
                                       <Typography>
                                      <b>Country:</b>{" "}
                                      {item.address.regionCode}
                                      </Typography>
                                    </span>
                                    {!item?.metadata?.hasVoiceOfMerchant&&<Typography color={"error"} sx={{ fontStyle: 'italic', fontSize:'13px'}}> <WarningAmberOutlinedIcon sx={{fontSize:'16px', verticalAlign: 'middle', marginRight: '4px'}}/> Unclaimed/Unverified <br/>
                                        Cannot respond to reviews or engage with customers
                                    </Typography>} 
                                    
                                  </div>
                                ) : (
                                  "N/A"
                                )}
                              </TableCell>
                            </TableRow>
                          ))}
                        </TableBody>}
                      </Table>
                      {!(_.size(data[accountName])>0&&_.some(data[accountName],a=>a.isLocaction===1))&&<Stack direction={'row'} sx={{width:'100%',py:3}} alignItems={'center'} justifyContent={'center'}>
                        <Typography color='error' fontStyle={'italic'}>{`No locations found in this Google Business Profile account.`} {noLocations?.length<=0&&`Please ensure at least one location is added and verified.`}</Typography>
                        </Stack>}
                    </TableContainer>
                   </>
                   
                  </div>
                ))}
              </div>
            </div>
            {/* <Stack direction="row" spacing={2} width={'100%'} mt={3} mb={1.5} alignItems={'center'} justifyContent={'center'}>  
            <Button
              variant="contained"
              color="primary"
              disabled={selectedRows.length === 0 || accountsData?.length === 0}
              sx={{width:'50%' }}
              onClick={handleButtonClick}
            >
              Finish Setup
            </Button>
            </Stack> */}
          </MainCard>
          {/* {!_.isEmpty(selectedAccountName) && openwarning && (
            <ConfirmModalTemplate
              open={openwarning}
              onClose={handleCloseWarning}
              {...warningDialog}
            />
          )} */}
          {/* {openNoLocationModal && !isGmbLoading && <ConfirmModalTemplate {...noLocationDialog} />} */}
        </div>
      }
    </>
  );
};

export default LocationList;